import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { cartFlowSequence } from "../miscellaneous/cartFlowSequence";
import { useLocation } from "./useLocation";

export function useCurrentPageIndex() {
  const { pathname } = useLocation();

  return cartFlowSequence.findIndex((page) => {
    return `${getPartnerPathnameClient(true)}${page.path}` === pathname;
  });
}
